var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-tabs',{staticStyle:{"margin-top":"10px"},attrs:{"type":"card"},on:{"change":_vm.callback}},[_c('a-tab-pane',{key:"1",attrs:{"tab":"Hallmark"}},[_c('hallmark')],1),_c('a-tab-pane',{key:"2",attrs:{"tab":"KEGG"}},[_c('kegg')],1),_c('a-tab-pane',{key:"3",attrs:{"tab":"WikiPathways"}},[_c('wiki')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }